// ABOUTME: UI configuration including icon sizes and other UI constants
// ABOUTME: Centralized place for tweaking UI properties

export type IconSize = 'small' | 'medium' | 'large';

interface IconSizeGroup {
  small: number;
  medium: number;
  large: number;
}

type IconSizeGroupName = 'button' | 'cardButton' | 'closeButton' | 'input';

const iconSizeGroups: Record<IconSizeGroupName, IconSizeGroup> = {
  // General action buttons (settings, copy notes, AI chat, clear board, archive)
  button: { small: 20, medium: 24, large: 28 },
  // Card/note buttons (expand/minimize, AI, dots, accept/reject, edge actions, inline pen)
  cardButton: { small: 10, medium: 12, large: 14 },
  // Close buttons in panels (Settings, Profile)
  closeButton: { small: 20, medium: 24, large: 28 },
  // Search and text input field icons
  input: { small: 10, medium: 12, large: 14 },
};

let currentIconSize: IconSize = 'medium';

export const ui = {
  iconSizes: iconSizeGroups,
  iconStrokeWidth: 2,
  setIconSize: (size: IconSize): void => {
    currentIconSize = size;
  },
  getIconSize: (group: IconSizeGroupName): number => {
    const config = iconSizeGroups[group];
    if (!config) {
      // Provide a helpful runtime error if an invalid group is requested
      const valid = Object.keys(iconSizeGroups).join(', ');
      throw new Error(`ui.getIconSize: invalid group "${String(group)}". Valid groups: ${valid}`);
    }
    return config[currentIconSize];
  },
  getIconSizePx: (group: IconSizeGroupName): string => {
    const size = ui.getIconSize(group);
    return `${size}px`;
  },
  getIconSizeRem: (group: IconSizeGroupName): string => {
    const size = ui.getIconSize(group);
    return `${size / 16}rem`;
  },
};
